export enum ContentType {
    ColumnChart = 'column',
    AreaChart = 'area',
    Table = 'table'
}
